import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { callRegionListGet, callRegionDelete } from '../../actions/regions' 
import { Link, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

let RegionList = ({ setPageAttr, list, methods: { callRegionListGet, callRegionDelete } }) => {
    let [searchParams] = useSearchParams();
    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callRegionDelete(id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callRegionListGet({}, pg)
                })
            }
        })
    }
    const headers = [
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'left',
            label: 'Cadastro'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <Link to={'/regions/edit/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-edit'></i></Link>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callRegionListGet({}, pg)
    }, [callRegionListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Regiões',
            caption: 'Configuração das regiões',
            btns: [
                {
                    type: 'link',
                    class: 'btn btn-primary',
                    icon: 'fas fa-plus',
                    label: 'Adicionar',
                    to: '/regions/add'
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/regions',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/regions'} />
    )
}

const mapStateToProps = ({ config: { regions: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callRegionListGet,
            callRegionDelete
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionList)